<!--
   Created by qing on 2020/12/19
   Des: 文件访问历史
-->
<template>

  <van-popup
    class="file-access-records-popup"
    v-model="visibleInfo.visible"
    :overlay="overlay"
    get-container="body"
    :style="{ height: popupHeight, width: '100%' }"
    :position="position">
    <div class="file-access-records-container" v-if="accessHistory">

      <div style="margin-top: 10px">
        <van-field label="文件名称">
          <template #input>
            <div>
              {{accessHistory.fileName}}
            </div>
          </template>
        </van-field>
        <van-field label="类型">
          <template #input>
            <svg class="icon" aria-hidden="true">
              <use :xlink:href="actionFileType2FileImage(accessHistory.fileType)"></use>
            </svg>
          </template>
        </van-field>

        <van-field label="文件大小">
          <template #input>
            <div>
              {{accessHistory.fileSize}}
            </div>
          </template>
        </van-field>

        <van-field label="上传人">
          <template #input>
            <div>
              {{accessHistory.uploadUserName}}
            </div>
          </template>
        </van-field>

        <van-field label="上传时间">
          <template #input>
            <div>
              {{actionFormatTime(accessHistory.createTime)}}
            </div>
          </template>
        </van-field>
        <van-field label="访问记录">
          <template #input>
            <div >
              {{accessHistory.visitCount}}次
            </div>
          </template>
        </van-field>

      </div>
      <div style="margin-top: 10px">

        <el-table
          :data="accessHistory.visitList"
          style="width: 100%">
          <el-table-column
            prop="userId"
            label="人员">
            <template slot-scope="scope" v-if="$store.getters.userListMap[scope.row.userId]">
              {{$store.getters.userListMap[scope.row.userId].nickname}}
            </template>
          </el-table-column>
          <el-table-column
            prop="timestamp"
            label="时间">
            <template slot-scope="scope">
              {{actionFormatTime(scope.row.timestamp)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="ipInfo"
            label="IP">
          </el-table-column>
          <el-table-column
            prop="ipAddress"
            label="地址">
          </el-table-column>
          <el-table-column
            prop="address"
            label="方式">
            <template slot-scope="scope">
              <van-tag
                v-if="scope.row.visitType === 'PREVIEW'"
                type="success"
                size="small">
                预览
              </van-tag>
              <van-tag
                v-if="scope.row.visitType === 'DOWNLOAD'"
                type="warning"
                size="small">
                下载
              </van-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

  </van-popup>
</template>

<script>
  import {accurateFormatDate, fileType2FileImage} from "../../../assets/js/Untis";

  export default {
    props: {
      mixFormId: {
        type: String,
        default: ''
      },
      stackList: {
        type: Array,
        default: () => []
      },
      popupHeight: {
        type: String,
        default: '100%'
      },
      position: {
        type: String,
        default: 'right'
      },
      overlay: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        visibleInfo: {
          nodeId: '',
          visible: false
        },
        accessHistory: null
      }
    },
    created() {
    },
    methods: {
      actionFormatTime(d) {
        return accurateFormatDate(d)
      },
      actionFileType2FileImage(fileType) {
        return fileType2FileImage(fileType)
      },

      open(fileUrl) {
        this.$store.dispatch('actionFilePreviewHistory', {
          fileUrl
        }).then(res => {
          this.accessHistory = res
        }).catch(console.error)
        this.stackList.push(this.visibleInfo)
        this.visibleInfo.visible = true
      },
    }
  }
</script>

<style lang="less">

  .file-access-records-popup {
    background-color: #F6F6F6 !important;

    .file-access-records-container {
      width: 100%;
      height: calc(100% - env(safe-area-inset-bottom));

      .icon {
        width: 30px;
        height: 30px;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
        margin-right: 10px;
      }
    }
  }
</style>